import { render, staticRenderFns } from "./HomeOrder.vue?vue&type=template&id=afb5fa6c&scoped=true&"
import script from "./HomeOrder.vue?vue&type=script&lang=js&"
export * from "./HomeOrder.vue?vue&type=script&lang=js&"
import style0 from "./HomeOrder.vue?vue&type=style&index=0&id=afb5fa6c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb5fa6c",
  null
  
)

export default component.exports